export const cardSx = { mb: 2 } as const;
export const pushRightSx = { marginLeft: 'auto' } as const;
export const flexRowCenteredItemsSx = { display: 'flex', alignItems: 'center', flexWrap: 'wrap' } as const;
export const defaultListIconSx = { ml: 2 } as const;
